import common from '@/../server/common'
import Login from './page/Login.vue'
import NoFind from './page/NoFind.vue'
import Home from './page/Home.vue'
import ExamRecord from './page/Exam/record.vue'
import ExamHistory from './page/Exam/history.vue'
import ExamAdd from './page/Exam/add.vue'
import ExamDetail from './page/Exam/detail.vue'
import ExamExercise from './page/Exam/exercise.vue'
import RecordDetail from './page/Exam/recordDetail.vue'
import JudgeList from './page/Exam/judgeList.vue'
import Judge from './page/Exam/judge.vue'
import userList from './page/User/list.vue'
import userAdd from './page/User/add.vue'

export default {
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '*',
    name: '/404',
    component: NoFind
  }, {
    path: '/',
    redirect: '/login'
  }, {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录'
    },
    component: Login
  }, {
    path: '/exam',
    meta: {
      verify: true,
      title: '试题管理',
      icon: 'fa fa-file-text-o',
      userType: 1,
    },
    component: Home,
    redirect: '/exam/record',
    children: [{
      path: 'record',
      meta: {
        verify: true,
        grade: common.page_grade.examRecord,
        title: '答题记录',
        icon: 'fa fa-th-large',
        userType: 1,
      },
      component: ExamRecord,
    }, {
      path: 'history',
      meta: {
        verify: true,
        grade: common.page_grade.examHistory,
        title: '历史试题',
        icon: 'fa fa-newspaper-o',
        userType: 1
      },
      component: ExamHistory
    }, {
      path: 'add',
      meta: {
        verify: true,
        grade: common.page_grade.examAdd,
        title: '添加试题',
        icon: 'fa fa-calendar-plus-o',
        userType: 0
      },
      component: ExamAdd
    }, {
      path: 'judgeList',
      meta: {
        verify: true,
        grade: common.page_grade.judgeList,
        title: '批改试卷',
        icon: 'fa fa-pencil-square-o',
        userType: 0
      },
      component: JudgeList
    }, {
      path: 'judge',
      meta: {
        verify: true,
        grade: common.page_grade.judge,
        title: '批改试卷',
        userType: 0
      },
      component: Judge
    }, {
      path: 'detail',
      meta: {
        verify: true,
        grade: common.page_grade.examDetail,
        title: '试题详情',
        userType: 1
      },
      component: ExamDetail
    }, {
      path: 'exercise',
      meta: {
        verify: true,
        grade: common.page_grade.startExercise,
        title: '开始答题',
        userType: 1
      },
      component: ExamExercise
    }, {
      path: 'recordDetail',
      meta: {
        verify: true,
        grade: common.page_grade.recordDetail,
        title: '详情',
        userType: 1
      },
      component: RecordDetail,
    }]
  }, {
    path: '/user',
    meta: {
      verify: true,
      title: '用户管理',
      icon: 'fa fa-user-o',
      userType: 1
    },
    redirect: '/user/list',
    component: Home,
    children: [{
      path: 'list',
      meta: {
        verify: true,
        grade: common.page_grade.userList,
        title: '用户列表',
        icon: 'fa fa-address-card-o',
        userType: 1
      },
      component: userList
    }, {
      path: 'add',
      meta: {
        verify: true,
        grade: common.page_grade.updateUser,
        title: '添加用户',
        icon: 'fa fa-user-plus',
        userType: 0
      },
      component: userAdd
    }]
  }]
}
